import { BASE_URL } from './config';

// Test tool: https://search.google.com/test/rich-results

export const getProductSchema = (product) => {
  const url = `${BASE_URL}/${product.category.slug}/${product.slug}`;

  let ratingStr = '';
  if (product.ratings && product.ratings.summary) {
    const reviews = product.ratings.reviews.map(
      (r) => `{
            "@type": "Review",
            "author": {
                "@type": "Person",
                "name": "${r.user}"
            },
            "reviewBody": "${r.text}",
            "reviewRating": {
              "@type": "Rating",
              "bestRating": "5",
              "ratingValue": "${r.ratingValue}",
              "worstRating": "1"
            }
          }`,
    );
    ratingStr = `,
"aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": ${product.ratings.summary.ratingValue},
    "ratingCount": ${product.ratings.summary.total}
}        
,"review": [${reviews.join(',')}]`;
  }

  const today = new Date();
  const gtin = product.defaultVariant?.metadata?.gtin || product.metadata.gtin;

  return `{
"@context": "https://schema.org/",
"@type": "Product",
"image": "${product.images.length > 0 ? product.images[0].url : ''}",
"name": "${product.name}",
"description": "${product.descriptionText}",
"url": "${url}",
"brand": { "@type": "Brand", "name": "${product.brand}" },
"sku": "${product.defaultVariant?.sku}",
${gtin ? '"gtin": "' + gtin + '",' : ''}
"category": "${product.category.name}",
"offers": {
    "@type": "Offer",
    "availability": "http://schema.org/InStock",
    "price": "${product.preis}",
    "priceValidUntil": "${new Date(
      today.setMonth(today.getMonth() + 1),
    ).toISOString()}",
    "priceCurrency": "CHF",
    "url": "${url}"
}${ratingStr}},{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "${product.category.name}",
            "item": "${BASE_URL}/${product.category.slug}"
        }
    ]}`;
};

export const getPostSchema = (post) => {
  const url = `${BASE_URL}/blog/${post._meta.uid}`;
  const date = post._meta.firstPublicationDate.split('T')[0];

  return `{ "@context": "https://schema.org", 
"@type": "BlogPosting",
"headline": "${post.title}",
"image": "${post.heading_image?.url}",
"keywords": "${post._meta.tags.join(' ')}", 
"publisher": ${'Edvin Weine'},
"url": "${url}",
"datePublished": "${date}",
"dateCreated": "${date}",
"dateModified": "${date}",
"description":"${post.lead}"
},{
"@context": "https://schema.org",
"@type": "BreadcrumbList",
"itemListElement": [
    {
        "@type": "ListItem",
        "position": 1,
        "name": "Blog",
        "item": "${BASE_URL}/blog"
    }
]}`;
};
